const SHOPIFY_STORE_URL = "https://www.wuselwerk.de/"; // Ersetze mit deinem Store-URL
const API_TOKEN = "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"; // Ersetze mit deinem Admin API Token
// Kunden-ID dynamisch anhand der E-Mail abrufen
async function getCustomerId(email) {
  const response = await fetch(
    `${SHOPIFY_STORE_URL}/admin/api/2023-01/customers/search.json?query=email:${email}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Access-Token": API_TOKEN,
      },
    }
  );

  if (response.ok) {
    const data = await response.json();
    return data.customers[0]?.id || null; // Gibt die Kunden-ID zurück
  } else {
    console.error("Fehler beim Abrufen der Kunden-ID:", await response.json());
  }
}


const catBreeds = [
  "Hauskatze",
  "Maine Coon",
  "Bengal",
  "Perser",
  "Siam",
  "Ragdoll",
  "Britisch Kurzhaar",
  "Sphynx",
  "Norwegische Waldkatze",
  "Savannah",
  "Andere",
];

const intolerances = [
  "Getreide",
  "Laktose",
  "Rind",
  "Huhn",
  "Fisch",
  "Soja",
  "Andere",
];

let cats = [];

const formContainer = document.getElementById("form-container");

function renderCats() {
  formContainer.innerHTML = "";
  cats.forEach((cat, index) => {
    const card = document.createElement("div");
    card.className = "card";

    if (cat.editing) {
      card.innerHTML = `
        <div class="form-group">
          <label for="cat-name-${index}">Name der Katze</label>
          <input type="text" id="cat-name-${index}" value="${cat.name}" />
        </div>

        <div class="form-group">
          <label for="cat-birthday-${index}">Geburtstag</label>
          <input type="date" id="cat-birthday-${index}" value="${cat.birthday || ""}" />
        </div>

        <div class="form-group">
          <label for="cat-breed-${index}">Rasse</label>
          <select id="cat-breed-${index}">
            ${catBreeds.map(
              (breed) =>
                `<option value="${breed}" ${
                  breed === cat.breed ? "selected" : ""
                }>${breed}</option>`
            ).join("")}
          </select>
        </div>

        <div class="form-group">
          <label>Lebensmittelunverträglichkeiten</label>
          ${intolerances
            .map(
              (intolerance) => `
            <div style="display: flex; align-items: center; gap: 10px;">
              <input type="checkbox" id="${intolerance}-${index}" ${
                cat.intolerances.includes(intolerance) ? "checked" : ""
              } />
              <label for="${intolerance}-${index}">${intolerance}</label>
            </div>
          `
            )
            .join("")}
        </div>

        <button onclick="saveEdit(${index})">Änderungen speichern</button>
      `;
    } else {
      card.innerHTML = `
        <div class="summary-item"><strong>Name:</strong> ${cat.name || "-"}</div>
        <div class="summary-item"><strong>Geburtstag:</strong> ${
          cat.birthday || "-"
        }</div>
        <div class="summary-item"><strong>Rasse:</strong> ${
          cat.breed || "-"
        }</div>
        <div class="summary-item"><strong>Unverträglichkeiten:</strong> ${
          cat.intolerances.length ? cat.intolerances.join(", ") : "Keine"
        }</div>
        <button class="edit-button" onclick="editCat(${index})">Bearbeiten</button>
      `;
    }

    formContainer.appendChild(card);
  });
}

function addCat() {
  cats.push({ name: "", birthday: "", breed: "", intolerances: [], editing: true });
  renderCats();
}

function editCat(index) {
  cats[index].editing = true;
  renderCats();
}

async function saveCatData(customerId, catData) {
  try {
    const metafields = [
      {
        namespace: "cat_profile",
        key: `cat_${Date.now()}_name`,
        value: catData.name,
        type: "single_line_text_field",
      },
      {
        namespace: "cat_profile",
        key: `cat_${Date.now()}_birthday`,
        value: catData.birthday,
        type: "date",
      },
      {
        namespace: "cat_profile",
        key: `cat_${Date.now()}_breed`,
        value: catData.breed,
        type: "single_line_text_field",
      },
      {
        namespace: "cat_profile",
        key: `cat_${Date.now()}_intolerances`,
        value: catData.intolerances.join(", "),
        type: "multi_line_text_field",
      },
    ];

    const response = await fetch(
      `${SHOPIFY_STORE_URL}/admin/api/2023-01/customers/${customerId}/metafields.json`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Access-Token": API_TOKEN,
        },
        body: JSON.stringify({ metafields }),
      }
    );

    if (response.ok) {
      console.log("Katzendaten erfolgreich gespeichert!");
    } else {
      console.error("Fehler beim Speichern:", await response.json());
    }
  } catch (error) {
    console.error("API-Fehler:", error);
  }
}

function saveEdit(index) {
  const catData = {
    name: document.getElementById(`cat-name-${index}`).value,
    birthday: document.getElementById(`cat-birthday-${index}`).value,
    breed: document.getElementById(`cat-breed-${index}`).value,
    intolerances: intolerances.filter(
      (intolerance) =>
        document.getElementById(`${intolerance}-${index}`).checked
    ),
  };

  const customerId = "123456789"; // Ersetze mit der tatsächlichen Kunden-ID
  saveCatData(customerId, catData).then(() => {
    cats[index] = { ...catData, editing: false };
    renderCats();
  });
}

document.getElementById("add-cat").addEventListener("click", addCat);
renderCats();
